class MMFaqDropdown extends HTMLElement {
	constructor() {
		super();
		this._handleDropdown = this.handleDropdown.bind(this);
		this._handleKeydown = this.handleKeydown.bind(this);
	}

	connectedCallback() {
		this.header = this.querySelector('[data-header]');
		this.content = this.querySelector('[data-content]');
		this.plusIcon = this.querySelector('.mm-icon-plus');
		this.minusIcon = this.querySelector('.mm-icon-minus');

		// Vérification que les éléments requis existent
		if (!this.header || !this.content) {
			console.error('mm-faq-dropdown: data-header ou data-content manquant');
			return;
		}

		// Initial state (les icônes sont gérées par CSS via aria-expanded)
		this.content.style.maxHeight = '0';
		this.content.style.display = 'none';
		this.header.setAttribute('aria-expanded', 'false');
		this.content.setAttribute('hidden', '');
		this.removeAttribute('open');

		this.header.addEventListener('click', this._handleDropdown);
		this.header.addEventListener('keydown', this._handleKeydown);
	}

	disconnectedCallback() {
		if (this.header) {
			this.header.removeEventListener('click', this._handleDropdown);
			this.header.removeEventListener('keydown', this._handleKeydown);
		}
	}

	handleKeydown(e) {
		if (e.key === ' ' || e.key === 'Enter') {
			e.preventDefault();
			this.handleDropdown();
		}
	}

	handleDropdown() {

// Ferme les autres dropdowns dans le même parent
		const siblings = Array.from(this.parentNode.children);
		siblings.forEach((el) => {
			if (el !== this && typeof el.closeDropdown === 'function') {
				el.closeDropdown();
			}
		});

// Toggle ce dropdown
		if (this.header.classList.contains('active')) {
			this.closeDropdown();
		} else {
			this.openDropdown();
		}
	}

	openDropdown() {
		this.header.classList.add('active');
		this.header.setAttribute('aria-expanded', 'true');
		this.setAttribute('open', '');

		// Retirer hidden et afficher le contenu
		this.content.removeAttribute('hidden');
		this.content.style.display = 'block';

		// Temporairement enlever max-height pour calculer la vraie hauteur
		this.content.style.maxHeight = 'none';
		const contentHeight = this.content.scrollHeight;

		// Partir de 0 pour l'animation
		this.content.style.maxHeight = '0';

		// Forcer un reflow pour que la transition fonctionne
		this.content.offsetHeight;

		// Puis animer l'ouverture vers la hauteur calculée
		requestAnimationFrame(() => {
			this.content.style.maxHeight = contentHeight + 'px';
		});
	}

	closeDropdown() {
		this.header.classList.remove('active');
		this.content.style.maxHeight = '0';
		const onEnd = () => {
			if (!this.header.classList.contains('active')) {
				this.content.setAttribute('hidden', '');
				this.content.style.display = 'none';
			}
		};
		this.content.addEventListener('transitionend', onEnd, { once: true });
		setTimeout(onEnd, 200);
		// Les icônes sont gérées par CSS via aria-expanded
		this.header.setAttribute('aria-expanded', 'false');
		this.removeAttribute('open');
	}

}

customElements.define('mm-faq-dropdown', MMFaqDropdown);
